import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Carousel = makeShortcode("Carousel");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Carousel slots="image, text1, text2" repeat="5" theme="light" enableNavigation className="carousel-padding-top-zero" mdxType="Carousel" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "576px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/42bd0c4045b5b4e1d10839da40533ee1/5530d/social_status_2x.webp 320w", "/document-services/static/42bd0c4045b5b4e1d10839da40533ee1/f1c97/social_status_2x.webp 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/42bd0c4045b5b4e1d10839da40533ee1/dd4a7/social_status_2x.png 320w", "/document-services/static/42bd0c4045b5b4e1d10839da40533ee1/694da/social_status_2x.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/42bd0c4045b5b4e1d10839da40533ee1/694da/social_status_2x.png",
            "alt": "Social status",
            "title": "Social status",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`“Our clients wanted to create PDFs of our reports and the open source solution we tried was difficult to work with and unreliable. We switched to the Adobe Services SDK because it produced higher quality PDFs and also let our clients convert to PowerPoint to customize reports for their audience.”`}</p>
    <p><strong parentName="p">{`– Tim Hill, CEO & Co-Founder, Social Status`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "576px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/51bb06f2939ba16aec7a9613ac9dc086/5530d/acumatica_2x.webp 320w", "/document-services/static/51bb06f2939ba16aec7a9613ac9dc086/f1c97/acumatica_2x.webp 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/51bb06f2939ba16aec7a9613ac9dc086/dd4a7/acumatica_2x.png 320w", "/document-services/static/51bb06f2939ba16aec7a9613ac9dc086/694da/acumatica_2x.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/51bb06f2939ba16aec7a9613ac9dc086/694da/acumatica_2x.png",
            "alt": "Acumatica",
            "title": "Acumatica",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`“We are committed to building superior collaboration and user experiences on our platform, and with PDF APIs from Adobe, we enabled the world’s best document experiences with ease — right within the Acumatica ERP solution.”`}</p>
    <p><strong parentName="p">{`– John Roskill, CEO, Acumatica Cloud ERP`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "576px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5ece50f12971ae243298e10f585c1795/5530d/k2_2x.webp 320w", "/document-services/static/5ece50f12971ae243298e10f585c1795/f1c97/k2_2x.webp 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5ece50f12971ae243298e10f585c1795/dd4a7/k2_2x.png 320w", "/document-services/static/5ece50f12971ae243298e10f585c1795/694da/k2_2x.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/5ece50f12971ae243298e10f585c1795/694da/k2_2x.png",
            "alt": "k2",
            "title": "k2",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`“Adobe Acrobat Services helped us extend K2’s intelligent process automation solution to enable
integrated PDF document creation with a rich, interactive web experience for document review,
approval, and e-signature processes with Adobe Acrobat Sign. Our developers were able to easily extend K2
workflows that collect information from multiple data sources using Adobe Acrobat Services APIs,
enabling us to quickly deliver a solution for our customers to automate their document-oriented business processes in a more secure and scalable way.”`}</p>
    <p><strong parentName="p">{`– Alex Cobb, VP Product Management, K2`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "576px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/17dd4f8ebe9e2d5c1e0dee2672d8fd0f/5530d/ninetynine_u_2x.webp 320w", "/document-services/static/17dd4f8ebe9e2d5c1e0dee2672d8fd0f/f1c97/ninetynine_u_2x.webp 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/17dd4f8ebe9e2d5c1e0dee2672d8fd0f/dd4a7/ninetynine_u_2x.png 320w", "/document-services/static/17dd4f8ebe9e2d5c1e0dee2672d8fd0f/694da/ninetynine_u_2x.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/17dd4f8ebe9e2d5c1e0dee2672d8fd0f/694da/ninetynine_u_2x.png",
            "alt": "Ninetynine u",
            "title": "Ninetynine u",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`“With the 99U Conference shifting to an all-virtual format this year, we wanted to make all aspects of the
event accessible to our attendees — especially The Creative Self Workbook, a workbook offering a
chance for deep self-discovery and exploration. The Adobe PDF Embed API allowed us to create an
accessible, seamless PDF experience with live form filling, notes, drawing, downloading, and printing
options with just a few lines of code.”`}</p>
    <p><strong parentName="p">{`– Andrea Rosen, Head of 99U`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "576px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/dda72874518ce03b2d70b1a3f52c61f4/5530d/infodesk_2x.webp 320w", "/document-services/static/dda72874518ce03b2d70b1a3f52c61f4/f1c97/infodesk_2x.webp 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/dda72874518ce03b2d70b1a3f52c61f4/dd4a7/infodesk_2x.png 320w", "/document-services/static/dda72874518ce03b2d70b1a3f52c61f4/694da/infodesk_2x.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/dda72874518ce03b2d70b1a3f52c61f4/694da/infodesk_2x.png",
            "alt": "Infodesk",
            "title": "Infodesk",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`“InfoDesk provides AI-driven technology and tools that enable organizations to make the smartest
decisions confidently. This involves delivering highly relevant insights to our customers in a format that
suits them best so they can harness the value of their information. By using Adobe’s Acrobat Services
API, our customers can easily convert PDF reports to PowerPoint for use in client presentations and
internal stakeholder meetings. At InfoDesk, we are always looking for ways to add value for our clients
and Adobe enables us to do exactly that.”`}</p>
    <p><strong parentName="p">{`– Lynn Epstein, COO, InfoDesk`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      